import React, { useState } from "react";
import "./ServiceCompleteSection.scss";
import Services from "../../api/service";
import { Link } from "react-router-dom";

const CompleteServiceSection = () => {
  const [services] = useState(Services);

  const handleClick = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="service_section_portfolio">
      <div className="heading_block text-center">
        <div className="heading_focus_text">
          Our
          <span className="badge bg-secondary text-white">Expertise</span>
        </div>
        <h2 className="heading_text mb-0">Featured Services</h2>
      </div>

      <div className="zigzag_wrapper">
        {services.map((service, index) => (
          <div
            className={`zigzag_row ${index % 2 === 0 ? "normal" : "reverse"}`}
            key={service.id}
          >
            <div className="zigzag_content">
              <h3 className="service_title">
                <a
                  onClick={() => handleClick(service.slug)}
                  href={`/${service.slug}`}
                >
                  {service.footer}
                </a>
              </h3>
              <p className="service_description">
                {service.service.length > 300
                  ? service.service.substring(0, 300) + "..."
                  : service.service}
              </p>

              {Array.isArray(service.TechStack) && service.TechStack.length > 0 && (
                <div className="tech_stack_section">
                  <h4>Tech Stack</h4>
                  <div className="tech_stack_list">
                    {service.TechStack.map((tech, techIndex) => (
                      <span key={techIndex} className="tech_badge">
                        <img src={tech} alt={tech} className="tech_image"/>
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <Link
                onClick={() => handleClick(service.slug)}
                to={`/${service.slug}`}
                className="icon_block_complete"
              >
                Go To {service.footer}
                <i className="fa-regular fa-arrow-up-right"></i>
              </Link>
            </div>

            <div className="zigzag_image">
              <img
                src={service.sImg}
                alt={service.title}
                className="service_img"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CompleteServiceSection;
